import { render, staticRenderFns } from "./TestDynamicComponentsPage.vue?vue&type=template&id=fac0b4e2&"
import script from "./TestDynamicComponentsPage.vue?vue&type=script&lang=js&"
export * from "./TestDynamicComponentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports